import { isElementHidden } from '../utilities/ElementHelpers'

document.addEventListener('DOMContentLoaded', () => {

  const root = document.documentElement
  let interval = 250;
  const scrollSettings = {
    didScroll: false,
    hasGonePastFirstComponent: false,       // has the pinned gone past the first component
    isPastFirstComponent: false,            // is the pinned currently past the first component
    lastScrollTop: 0,
    delta: 5,
    cssVarStickyOffsetTopNav: '--stickyTopOffsetTopNav',
    cssVarStickyOffsetUtilityNav: '--stickyTopOffsetUtilityNav',
    cssVarStickyOffsetMain: '--stickyOffsetMain',
    cssClassPositionFixed: 'position-fixed',
    cssClassNavUp: 'nav-up',
    cssClassNavDown: 'nav-down'
  }

  const topUtilityNavEl = document.getElementById('topUtilityNav')
  const topNavEl = document.getElementById('topNav')
  const firstComponentEl = document.querySelector<HTMLElement>('main .component:first-of-type')
  const alertElsTotalHeight = [...document.querySelectorAll<HTMLElement>('.alert-banner')].reduce((cur, val) => cur + val.offsetHeight, 0);

  if (firstComponentEl === null || isElementHidden(topUtilityNavEl) || window.document['documentMode'] !== undefined) {
    // exit if utility nav is hidden || IE11 or below
    return
  }

  // helper
  const toggleNavPosition = function (navEl, shouldHide) {
    const removeClass = shouldHide ? scrollSettings.cssClassNavDown : scrollSettings.cssClassNavUp
    const addClass = shouldHide ? scrollSettings.cssClassNavUp : scrollSettings.cssClassNavDown

    navEl.classList.remove(removeClass)
    navEl.classList.add(addClass)
  }

  // set css var offsets for navs
  root.style.setProperty(scrollSettings.cssVarStickyOffsetTopNav, `0px`)

  // trigger scroll logic initially
  hasScrolled()

  // scroll listener
  window.addEventListener('scroll', function () {
    scrollSettings.didScroll = true
  })

  setInterval(function () {
    if (scrollSettings.didScroll) {
      hasScrolled()
      scrollSettings.didScroll = false
    }
  }, interval)

  // scroll logic
  function hasScrolled() {
    const distanceFromTop = window.pageYOffset || document.documentElement.scrollTop
    const documentHeight = document.documentElement.scrollHeight
    const viewportHeight = window.innerHeight

    // scroll has to be more or equal to the delta
    if (Math.abs(scrollSettings.lastScrollTop - distanceFromTop) <= scrollSettings.delta)
      return

    // if scrolled down and past the navbar, add class .nav-up.
    if (distanceFromTop > scrollSettings.lastScrollTop && distanceFromTop > topUtilityNavEl.offsetHeight + alertElsTotalHeight) {
      // scrolled down - past utility nav
      // console.log(`scrolled down - ${distanceFromTop}`)

      topNavEl.classList.add(scrollSettings.cssClassPositionFixed)
      root.style.setProperty(scrollSettings.cssVarStickyOffsetMain, `${topUtilityNavEl.classList.contains(scrollSettings.cssClassPositionFixed) ? topNavEl.offsetHeight + topUtilityNavEl.offsetHeight : topNavEl.offsetHeight}px`)

      // scrolled down - halfway past the first component
      if (distanceFromTop > (topUtilityNavEl.offsetHeight + (firstComponentEl.offsetHeight / 2))) {
        // console.log(`scrolled down past - ${distanceFromTop}`)
        interval = 250
        scrollSettings.hasGonePastFirstComponent = true
        scrollSettings.isPastFirstComponent = true
        root.style.setProperty(scrollSettings.cssVarStickyOffsetTopNav, `${topNavEl.offsetHeight}px`)
        root.style.setProperty(scrollSettings.cssVarStickyOffsetUtilityNav, `${topUtilityNavEl.offsetHeight}px`)

        toggleNavPosition(topNavEl, true)
        toggleNavPosition(topUtilityNavEl, true)
      } else {
        scrollSettings.hasGonePastFirstComponent = false
      }
    } else {
      // scroll Up
      if (distanceFromTop + viewportHeight < documentHeight) {
        // console.log(`scrolled up - ${distanceFromTop}`)

        // if the main nav is not pinned, make it so
        if (!topNavEl.classList.contains(scrollSettings.cssClassNavDown)) {
          root.style.setProperty(scrollSettings.cssVarStickyOffsetTopNav, `${topUtilityNavEl.offsetHeight}px`)

          // pin the utility nav
          if (scrollSettings.hasGonePastFirstComponent) {
            root.style.setProperty(scrollSettings.cssVarStickyOffsetUtilityNav, `0px`)
            root.style.setProperty(scrollSettings.cssVarStickyOffsetTopNav, `${topUtilityNavEl.offsetHeight}px`)
            root.style.setProperty(scrollSettings.cssVarStickyOffsetMain, `${topNavEl.offsetHeight + topUtilityNavEl.offsetHeight}px`)

            topUtilityNavEl.classList.add(scrollSettings.cssClassPositionFixed)
            toggleNavPosition(topUtilityNavEl, false)
          }

          toggleNavPosition(topNavEl, false)
        }

        // if scrolled up past first component for the first time
        if (scrollSettings.isPastFirstComponent && distanceFromTop <= ((topNavEl.offsetHeight + topUtilityNavEl.offsetHeight) + (firstComponentEl.offsetHeight / 2))) {
          scrollSettings.isPastFirstComponent = false;
          interval = 150
        }

        // if the utility nav is reached, dettach the main nav
        if (distanceFromTop <= topUtilityNavEl.offsetHeight + alertElsTotalHeight) {
          topNavEl.classList.remove('position-fixed')
          topUtilityNavEl.classList.remove('position-fixed')
          root.style.setProperty(scrollSettings.cssVarStickyOffsetTopNav, '0px')
          root.style.setProperty(scrollSettings.cssVarStickyOffsetUtilityNav, '0px')
          root.style.setProperty(scrollSettings.cssVarStickyOffsetMain, '0px')
        }
      }
    }

    scrollSettings.lastScrollTop = distanceFromTop
  }
})
